
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-stories",
      function () {
        return require("private-next-pages/web-stories/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-stories"])
      });
    }
  